import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

$(document).ready(function () {
    const swiper = new Swiper('.js__main_slider', {
        slidesPerView: 1,
        loop: false,

        modules: [Navigation, Pagination],
        navigation: {
            nextEl: '.main__swiper__next',
            prevEl: '.main__swiper__prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });


    let swiperPriorities = null;

    function toggleSwiperPriorities() {
        if ($(window).width() < 920 && !swiperPriorities) {
            swiperPriorities = new Swiper('.js__priorities_slider', {
                slidesPerView: 1,
                loop: true,
                modules: [Pagination],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        } else if ($(window).width() >= 920 && swiperPriorities) {
            swiperPriorities.destroy(true, true);
            swiperPriorities = null;
        }
    }
    toggleSwiperPriorities();
    $(window).resize(toggleSwiperPriorities);


    let swiperServices = null;

    function toggleSwiperServices() {
        if ($(window).width() < 920 && !swiperServices) {
            swiperServices = new Swiper('.js__services_slider', {
                slidesPerView: 1,
                loop: true,
                modules: [Pagination],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        } else if ($(window).width() >= 920 && swiperServices) {
            swiperServices.destroy(true, true);
            swiperServices = null;
        }
    }
    toggleSwiperServices();
    $(window).resize(swiperServices);
});
